import { render, staticRenderFns } from "./DataClientRegions.vue?vue&type=template&id=34a1d0e3"
import script from "./DataClientRegions.vue?vue&type=script&lang=js"
export * from "./DataClientRegions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports